export default "__VITE_ASSET__RMVClrHW__"